
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST,
    MOVE_TO_ANOTHER_ACCOUNT_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { moveToAnotherAccountGetKeyFobResult, moveToAnotherAccountResult } from 'Redux/actions';


function* getKeyFobs({ payload }) {
    try {

        let { devices } = payload;
        const QUERY = `
        query searchKeyFobs ($conditions: [KeyFobSearchInput], $sort: [KeyFobSortInput], $limit: Int, $offset: Int) {
            result: searchKeyFobs (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    companyId
                    id
                    hex
                    company {
                        id
                        name
                    }
                    keyFobModel {
                        id
                        name
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["hex"],
                    terms: payload,
                    exact: true
                },
                limit: 500,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(moveToAnotherAccountGetKeyFobResult(data?.result))
        } else {
            yield put(moveToAnotherAccountGetKeyFobResult({ error: true }))
        }

    } catch (exc) {
        yield put(moveToAnotherAccountGetKeyFobResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/moveToAnotherAccount/redux/saga",
            "getKeyFobs",
        )
    }
}

function* moveToAnotherAccount({ payload }) {
    try {
        let { keyFobIds, newAccountId } = payload
        let QUERY = ` 
            
            mutation moveToAnotherAccount ($keyFobIds: [String]!, $companyId: Int!) {
                moveToAnotherAccount (keyFobIds: $keyFobIds, companyId: $companyId)
            }
        
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                keyFobIds: keyFobIds,
                companyId: newAccountId
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) { //data?.result
            yield put(moveToAnotherAccountResult({ updateMoveAccount: true }))
        } else {
            yield put(moveToAnotherAccountResult({ updateMoveAccount: false }))
        }

    } catch (exc) {
        yield put(moveToAnotherAccountResult({ updateMoveAccount: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/moveToAnotherAccount/redux/saga",
            "moveToAnotherAccount",
        )
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    status
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/keysFobs/.components/moveToAnotherAccount/redux/saga', 'getAccounts');
    }
}

function* watchMethods() {
    yield takeEvery(MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST, getKeyFobs);
    yield takeEvery(MOVE_TO_ANOTHER_ACCOUNT_REQUEST, moveToAnotherAccount);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}